import { t } from 'i18next';

import { TreeItemType } from '@features/campaigns/builder/containers/FormPages/FormPages.types.ts';
import { GeoTargetingConfig } from '@features/campaigns/shared/config/geoTargetingConfig.ts';
import { i18nNameSpace } from '@shared/consts/i18n.ts';

export function appendGeoTypeSuffix(name: string, treeItemType: TreeItemType, config: GeoTargetingConfig): string {
  if (!config.showTypeSuffixes) {
    return name;
  }

  const translationKey =
    treeItemType === TreeItemType.Province
      ? config.treeLevel2SuffixTranslationKey
      : config.treeLevel3SuffixTranslationKey;

  return `${name} (${t(translationKey, { ns: i18nNameSpace.CAMPAIGNS })})`;
}
